var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.formList, function (item, index) {
      return _c(
        "div",
        { key: index },
        [
          item.formField
            ? _c("div", [
                item.formField.fieldName == "描述" && !item.formField.type
                  ? _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "info_key" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#ff4d42", width: "11px" },
                            },
                            [
                              item.formField.createFlage == "1"
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            staticClass: "iconfont icon-describe info_icon",
                            staticStyle: { "font-size": "14px" },
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: "描述",
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [_c("div", [_vm._v("描述")])]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "85%", "margin-top": "5px" } },
                        [
                          _c("Describe", {
                            attrs: {
                              describes: _vm.describes,
                              formdetail: _vm.formdetail,
                            },
                            on: { func: _vm.addtask },
                          }),
                        ],
                        1
                      ),
                    ])
                  : item.formField.fieldName == "标签" && !item.formField.type
                  ? _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "info_key" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#ff4d42", width: "11px" },
                            },
                            [
                              item.formField.createFlage == "1"
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            staticClass: "iconfont icon-tag info_icon",
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: "标签",
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [_c("div", [_vm._v("标签")])]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "info_value" }, [
                        _c(
                          "div",
                          { staticClass: "info_box" },
                          [
                            _vm._l(
                              _vm.dialogCreat.labelList,
                              function (tag, index1) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.dialogCreat.labelList &&
                                          _vm.dialogCreat.labelList.length > 0,
                                        expression:
                                          "dialogCreat.labelList && dialogCreat.labelList.length > 0",
                                      },
                                    ],
                                    key: index1,
                                    staticClass: "info_tags",
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: { "margin-right": "16px" },
                                        style:
                                          "color:" +
                                          tag.color +
                                          ";background:" +
                                          _vm.convertHex(tag.color, 10),
                                        attrs: { type: "warning" },
                                      },
                                      [_vm._v(_vm._s(tag.labelName))]
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-shanchu del_icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.delTagsChange(tag)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  width: "540",
                                  trigger: "click",
                                },
                              },
                              [
                                _c("TagsList", {
                                  attrs: {
                                    "tags-objects": _vm.tagsObject,
                                    "tag-lists": _vm.tagList,
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-jiahao2fill add_icon",
                                  style:
                                    item.labelList && item.labelList.length > 0
                                      ? "margin: 0 10px;line-height: 30px;"
                                      : "margin: 0;line-height: 30px;",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "info_key" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#ff4d42", width: "11px" },
                            },
                            [
                              item.formField.createFlage == "1"
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            staticClass: "iconfont info_icon",
                            class: _vm.getIconClass(item.type),
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: item.formField.fieldName,
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [
                              _c("div", { staticClass: "form_fieldName" }, [
                                _vm._v(_vm._s(item.formField.fieldName)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      item.formField.type == "0" || item.formField.type == "1"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c("div", { staticStyle: { width: "100%" } }, [
                              item.formField.type == "0"
                                ? _c(
                                    "div",
                                    [
                                      _c("el-input", {
                                        ref: item.id,
                                        refInFor: true,
                                        attrs: {
                                          autofocus: true,
                                          placeholder: "点击添加",
                                        },
                                        on: { change: _vm.addFormData },
                                        model: {
                                          value: item.fieldValue,
                                          callback: function ($$v) {
                                            _vm.$set(item, "fieldValue", $$v)
                                          },
                                          expression: "item.fieldValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.formField.type == "1"
                                ? _c(
                                    "div",
                                    [
                                      _c("el-input", {
                                        ref: item.id,
                                        refInFor: true,
                                        attrs: {
                                          type: "number",
                                          autofocus: true,
                                          oninput:
                                            "if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.numValue(item)
                                          },
                                          change: _vm.addFormData,
                                        },
                                        model: {
                                          value: item.fieldValue,
                                          callback: function ($$v) {
                                            _vm.$set(item, "fieldValue", $$v)
                                          },
                                          expression: "item.fieldValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : item.formField.type == "2"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("Describe", {
                                  attrs: {
                                    describes: item.describes,
                                    formdetail: _vm.formdetail,
                                    "form-data": item,
                                  },
                                  on: { func: _vm.addDescs },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm.uploadType === "ding" &&
                          item.formField.type == "3"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c("div", { staticStyle: { width: "100%" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "uploadfile",
                                  staticStyle: {
                                    width: "calc(100% - 11px)",
                                    "margin-left": "11px",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFile(item)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-a-02beifen2 file_icon",
                                  }),
                                  _c("span", { staticClass: "test" }, [
                                    _vm._v("附件"),
                                  ]),
                                ]
                              ),
                              item.files && item.files.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "file_lists" },
                                    _vm._l(
                                      item.files,
                                      function (file, index_file) {
                                        return _c(
                                          "div",
                                          {
                                            key: index_file,
                                            staticClass: "file_boxs",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file_text",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.previewFile(file)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-wenjian file__icon",
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(file.fileName)),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-shanchu1 del__icon",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delFunFile(
                                                    file,
                                                    index_file,
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : _vm.uploadType === "oss" && item.formField.type == "3"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c("div", { staticStyle: { width: "100%" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "uploadfile",
                                  staticStyle: {
                                    width: "calc(100% - 11px)",
                                    "margin-left": "11px",
                                  },
                                },
                                [
                                  _c("multi-upload", {
                                    attrs: {
                                      "file-data": {
                                        objectType: "1",
                                        objectId: "",
                                        type: "15",
                                        taskId: "",
                                        proId: _vm.proId,
                                        source: "oss",
                                        versionId: "",
                                        fieldId: item.formField.id,
                                      },
                                      "upload-btn": _vm.uploadBtn,
                                    },
                                    on: { setFileList: _vm.successFile },
                                  }),
                                ],
                                1
                              ),
                              item.files && item.files.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "file_lists" },
                                    _vm._l(
                                      item.files,
                                      function (file, index_file) {
                                        return _c(
                                          "div",
                                          {
                                            key: index_file,
                                            staticClass: "file_boxs",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "file_text",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.previewFile(file)
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-wenjian file__icon",
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(file.fileName)),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-shanchu1 del__icon",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.delFunFile(
                                                    file,
                                                    index_file,
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : item.formField.type == "4"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              [
                                _c("el-date-picker", {
                                  ref: item.id,
                                  refInFor: true,
                                  attrs: {
                                    type: "datetime",
                                    placeholder: "选择日期时间",
                                    "value-format": "yyyy/MM/dd HH:mm:ss",
                                    format: "yyyy/MM/dd HH:mm:ss",
                                  },
                                  on: { change: _vm.addFormData },
                                  model: {
                                    value: item.fieldValue,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fieldValue", $$v)
                                    },
                                    expression: "item.fieldValue",
                                  },
                                }),
                              ],
                              1
                            ),
                          ])
                        : item.formField.type == "5"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              { staticClass: "info_value_text" },
                              [
                                _c("span", [_vm._v(_vm._s(item.addressName))]),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        "PC端不支持位置功能，请在手机端选择！",
                                      placement: "bottom",
                                      "popper-class": "texttooltip",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-bianzu info_icon",
                                      style: item.addressName
                                        ? "margin-left:5px"
                                        : "",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ])
                        : item.formField.type == "17"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              { staticClass: "info_value_text" },
                              [
                                item.files && item.files.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "file_lists" },
                                      _vm._l(
                                        item.files,
                                        function (fileItem, index_file) {
                                          return _c(
                                            "div",
                                            {
                                              key: index_file,
                                              staticClass: "file_boxs",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "file_text",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.previewFile(
                                                        _vm.file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-wenjian file__icon",
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(fileItem.fileName)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-shanchu1 del__icon",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.delFunFile(
                                                      fileItem,
                                                      index_file,
                                                      item
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content:
                                            "PC端不支持拍照功能，请在手机端进行拍照！",
                                          placement: "bottom",
                                          "popper-class": "texttooltip",
                                          "open-delay": 500,
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "iconfont icon-xiangji1 info_icon",
                                        }),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ])
                        : item.formField.type == "6"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "calc(100% - 11px)",
                                  "padding-left": "11px",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    on: { change: _vm.addFormData },
                                    model: {
                                      value: item.fieldValue,
                                      callback: function ($$v) {
                                        _vm.$set(item, "fieldValue", $$v)
                                      },
                                      expression: "item.fieldValue",
                                    },
                                  },
                                  _vm._l(
                                    item.formField.optionsArray,
                                    function (key) {
                                      return _c(
                                        "el-radio",
                                        {
                                          key: key.key,
                                          attrs: { label: key.key },
                                        },
                                        [_vm._v(_vm._s(key.value))]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : item.formField.type == "7"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "calc(100% - 11px)",
                                  "padding-left": "11px",
                                },
                              },
                              [
                                _c(
                                  "el-checkbox-group",
                                  {
                                    on: {
                                      change: function ($event) {
                                        return _vm.checkboxChange1(
                                          index,
                                          item.strArray
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.strArray,
                                      callback: function ($$v) {
                                        _vm.$set(item, "strArray", $$v)
                                      },
                                      expression: "item.strArray",
                                    },
                                  },
                                  _vm._l(
                                    item.formField.optionsArray,
                                    function (key) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: key.key,
                                          attrs: { label: key.key },
                                        },
                                        [_vm._v(_vm._s(key.value))]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : item.formField.type == "8"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    ref: item.id,
                                    refInFor: true,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择内容",
                                    },
                                    on: { change: _vm.addFormData },
                                    model: {
                                      value: item.fieldValue,
                                      callback: function ($$v) {
                                        _vm.$set(item, "fieldValue", $$v)
                                      },
                                      expression: "item.fieldValue",
                                    },
                                  },
                                  _vm._l(
                                    item.formField.optionsArray,
                                    function (key) {
                                      return _c("el-option", {
                                        key: key.key,
                                        attrs: {
                                          label: key.value,
                                          value: key.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : item.formField.type == "9"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    ref: item.id,
                                    refInFor: true,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择内容",
                                      multiple: "",
                                      "collapse-tags": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.checkboxChange1(
                                          index,
                                          item.strArray
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.strArray,
                                      callback: function ($$v) {
                                        _vm.$set(item, "strArray", $$v)
                                      },
                                      expression: "item.strArray",
                                    },
                                  },
                                  _vm._l(
                                    item.formField.optionsArray,
                                    function (key) {
                                      return _c("el-option", {
                                        key: key.key,
                                        attrs: {
                                          label: key.value,
                                          value: key.key,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : item.formField.type == "10" ||
                          item.formField.type == "11"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c("div", { staticClass: "personnel" }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    display: "flex",
                                    "align-items": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "draggable",
                                    {
                                      style:
                                        _vm.creatType === "waixie"
                                          ? ""
                                          : "max-width: calc(100% - 45px)",
                                      attrs: {
                                        group: "responseUsers",
                                        options: { handle: ".info_personnel1" },
                                        animation: "500",
                                      },
                                      model: {
                                        value: item.users,
                                        callback: function ($$v) {
                                          _vm.$set(item, "users", $$v)
                                        },
                                        expression: "item.users",
                                      },
                                    },
                                    [
                                      _c(
                                        "transition-group",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-wrap": "wrap",
                                          },
                                        },
                                        _vm._l(
                                          item.users,
                                          function (user, index2) {
                                            return _c(
                                              "div",
                                              {
                                                key: index2,
                                                staticStyle: {
                                                  "margin-left": "11px",
                                                },
                                              },
                                              [
                                                _vm.channel === "wechat"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "user_personnel",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                          },
                                                          [
                                                            user.avatar != "" &&
                                                            user.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: user.avatar,
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "ww-open-data",
                                                                  {
                                                                    attrs: {
                                                                      type: "userName",
                                                                      openid:
                                                                        user.name,
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-shanchu del_icon",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.delUsers(
                                                                item.users,
                                                                index2,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "user_personnel",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "info_personnel1",
                                                          },
                                                          [
                                                            user.avatar != "" &&
                                                            user.avatar != null
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                  attrs: {
                                                                    src: user.avatar,
                                                                  },
                                                                })
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info_personnel_surname1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          user.name.substring(
                                                                            0,
                                                                            1
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  user.name
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-shanchu del_icon",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.delUsers(
                                                                item.users,
                                                                index2,
                                                                index
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      _vm.creatType === "waixie"
                                        ? _c("candidate", {
                                            attrs: {
                                              "is-multiple":
                                                item.formField.type == "10"
                                                  ? false
                                                  : true,
                                              "is-show-icon": true,
                                              "setect-user": item.users,
                                            },
                                            on: {
                                              getSetectUser: function (val) {
                                                return _vm.setupTaskFollow(
                                                  val,
                                                  index,
                                                  item.formField.type
                                                )
                                              },
                                            },
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "iconfont icon-jiahao2fill add_icon",
                                            staticStyle: { margin: "0 24px" },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.contactCh(
                                                  item.users,
                                                  index,
                                                  item.formField.type
                                                )
                                              },
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ])
                        : _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              { staticStyle: { width: "100%" } },
                              [
                                _c("el-input", {
                                  ref: item.id,
                                  refInFor: true,
                                  attrs: {
                                    autofocus: true,
                                    placeholder: "点击添加",
                                  },
                                  on: { change: _vm.addFormData },
                                  model: {
                                    value: item.fieldValue,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fieldValue", $$v)
                                    },
                                    expression: "item.fieldValue",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                    ]),
              ])
            : _c("div", [
                item.fieldName == "描述" && !item.type
                  ? _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "info_key" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#ff4d42", width: "11px" },
                            },
                            [
                              item.createFlage == "1"
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            staticClass: "iconfont icon-describe info_icon",
                            staticStyle: { "font-size": "14px" },
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: "描述",
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [_c("div", [_vm._v("描述")])]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "85%", "margin-top": "5px" } },
                        [
                          _c("Describe", {
                            attrs: { describes: _vm.describes },
                            on: { func: _vm.addtask },
                          }),
                        ],
                        1
                      ),
                    ])
                  : item.fieldName == "标签" && !item.type
                  ? _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "info_key" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#ff4d42", width: "11px" },
                            },
                            [
                              item.createFlage == "1"
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            staticClass: "iconfont icon-tag info_icon",
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: "标签",
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [_c("div", [_vm._v("标签")])]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "info_value" }, [
                        _c(
                          "div",
                          { staticClass: "info_box" },
                          [
                            _vm._l(
                              _vm.dialogCreat.labelList,
                              function (tag, index1) {
                                return _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.dialogCreat.labelList &&
                                          _vm.dialogCreat.labelList.length > 0,
                                        expression:
                                          "dialogCreat.labelList && dialogCreat.labelList.length > 0",
                                      },
                                    ],
                                    key: index1,
                                    staticClass: "info_tags",
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: { "margin-right": "16px" },
                                        style:
                                          "color:" +
                                          tag.color +
                                          ";background:" +
                                          _vm.convertHex(tag.color, 10),
                                        attrs: { type: "warning" },
                                      },
                                      [_vm._v(_vm._s(tag.labelName))]
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-shanchu del_icon",
                                      on: {
                                        click: function ($event) {
                                          return _vm.delTagsChange(tag)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "bottom",
                                  width: "540",
                                  trigger: "click",
                                },
                              },
                              [
                                _c("TagsList", {
                                  attrs: {
                                    "tags-objects": _vm.tagsObject,
                                    "tag-lists": _vm.tagList,
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "iconfont icon-jiahao2fill add_icon",
                                  style:
                                    item.labelList && item.labelList.length > 0
                                      ? "margin: 0 10px;line-height: 30px;"
                                      : "margin: 0;line-height: 30px;",
                                  attrs: { slot: "reference" },
                                  slot: "reference",
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "info_key" },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#ff4d42", width: "11px" },
                            },
                            [
                              item.createFlage == "1"
                                ? _c("span", [_vm._v("*")])
                                : _vm._e(),
                            ]
                          ),
                          _c("i", {
                            staticClass: "iconfont info_icon",
                            class: _vm.getIconClass(item.type),
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: item.fieldName,
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [
                              _c("div", { staticClass: "form_fieldName" }, [
                                _vm._v(_vm._s(item.fieldName)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      item.type == "0"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c("el-input", {
                                ref: "input_name",
                                refInFor: true,
                                attrs: {
                                  autofocus: true,
                                  placeholder: "点击添加",
                                },
                                on: { change: _vm.addFormData },
                                model: {
                                  value: item.fieldValue,
                                  callback: function ($$v) {
                                    _vm.$set(item, "fieldValue", $$v)
                                  },
                                  expression: "item.fieldValue",
                                },
                              }),
                            ],
                            1
                          )
                        : item.type == "1"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c("el-input", {
                                ref: "input_name",
                                refInFor: true,
                                attrs: {
                                  type: "'number'",
                                  autofocus: true,
                                  placeholder: "点击添加",
                                  oninput:
                                    "if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.numValue(item)
                                  },
                                  change: _vm.addFormData,
                                },
                                model: {
                                  value: item.fieldValue,
                                  callback: function ($$v) {
                                    _vm.$set(item, "fieldValue", $$v)
                                  },
                                  expression: "item.fieldValue",
                                },
                              }),
                            ],
                            1
                          )
                        : item.type == "2"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c("Describe", {
                                attrs: { describes: item.describes },
                                on: { func: _vm.addDescs },
                              }),
                            ],
                            1
                          )
                        : item.type == "3" && _vm.uploadType === "ding"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c("div", { staticStyle: { width: "100%" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "uploadfile",
                                  on: {
                                    click: function ($event) {
                                      return _vm.uploadFile(item)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-a-02beifen2 file_icon",
                                  }),
                                  _c("span", { staticClass: "test" }, [
                                    _vm._v("附件"),
                                  ]),
                                ]
                              ),
                              item.fileList && item.fileList.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "file_lists" },
                                    _vm._l(
                                      item.fileList,
                                      function (file, index_file) {
                                        return _c(
                                          "div",
                                          {
                                            key: index_file,
                                            staticClass: "file_boxs",
                                            on: {
                                              click: function ($event) {
                                                return _vm.previewFile(file)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "file_text" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-wenjian file__icon",
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(file.fileName)),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-shanchu1 del__icon",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.delFun(
                                                    file,
                                                    index_file,
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : item.type == "3" && _vm.uploadType === "oss"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c("div", { staticStyle: { width: "100%" } }, [
                              _c(
                                "div",
                                { staticClass: "uploadfile" },
                                [
                                  _c("multi-upload", {
                                    attrs: {
                                      "file-data": {
                                        objectType: "1",
                                        objectId: "",
                                        type: "15",
                                        proId: _vm.proId,
                                        source: "oss",
                                        versionId: "",
                                        fieldId: item.id,
                                      },
                                      "upload-btn": _vm.uploadBtn,
                                    },
                                    on: { setFileList: _vm.successFile },
                                  }),
                                ],
                                1
                              ),
                              item.fileList && item.fileList.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "file_lists" },
                                    _vm._l(
                                      item.fileList,
                                      function (file, index_file) {
                                        return _c(
                                          "div",
                                          {
                                            key: index_file,
                                            staticClass: "file_boxs",
                                            on: {
                                              click: function ($event) {
                                                return _vm.previewFile(file)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "file_text" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-wenjian file__icon",
                                                }),
                                                _c("span", [
                                                  _vm._v(_vm._s(file.fileName)),
                                                ]),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-shanchu1 del__icon",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.delFun(
                                                    file,
                                                    index_file,
                                                    item
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : item.type == "4"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择日期时间",
                                  "value-format": "yyyy/MM/dd HH:mm:ss",
                                  format: "yyyy/MM/dd HH:mm:ss",
                                },
                                on: { change: _vm.addFormData },
                                model: {
                                  value: item.fieldValue,
                                  callback: function ($$v) {
                                    _vm.$set(item, "fieldValue", $$v)
                                  },
                                  expression: "item.fieldValue",
                                },
                              }),
                            ],
                            1
                          )
                        : item.type == "5"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "PC端不支持位置功能，请在手机端选择！",
                                    placement: "top",
                                    "popper-class": "texttooltip",
                                    "open-delay": 500,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-bianzu info_icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : item.type == "17"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "PC端不支持拍照功能，请在手机端进行拍照！",
                                    placement: "top",
                                    "popper-class": "texttooltip",
                                    "open-delay": 500,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-xiangji1 info_icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          )
                        : item.type == "6"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.addFormData },
                                  model: {
                                    value: item.fieldValue,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fieldValue", $$v)
                                    },
                                    expression: "item.fieldValue",
                                  },
                                },
                                _vm._l(item.optionsArray, function (key) {
                                  return _c(
                                    "el-radio",
                                    { key: key.key, attrs: { label: key.key } },
                                    [_vm._v(_vm._s(key.value))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : item.type == "7"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  on: { change: _vm.checkboxChange },
                                  model: {
                                    value: item.fieldValue,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fieldValue", $$v)
                                    },
                                    expression: "item.fieldValue",
                                  },
                                },
                                _vm._l(item.optionsArray, function (key) {
                                  return _c(
                                    "el-checkbox",
                                    { key: key.key, attrs: { label: key.key } },
                                    [_vm._v(_vm._s(key.value))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : item.type == "8" || item.type == "9"
                        ? _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择内容",
                                    multiple: item.type == "9",
                                    "collapse-tags": "",
                                  },
                                  on: { change: _vm.addFormData },
                                  model: {
                                    value: item.fieldValue,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fieldValue", $$v)
                                    },
                                    expression: "item.fieldValue",
                                  },
                                },
                                _vm._l(item.optionsArray, function (key) {
                                  return _c("el-option", {
                                    key: key.key,
                                    attrs: { label: key.value, value: key.key },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : item.type == "10" || item.type == "11"
                        ? _c("div", { staticClass: "info_value" }, [
                            _c(
                              "div",
                              {
                                staticClass: "personnel",
                                staticStyle: {
                                  width: "83%",
                                  display: "flex",
                                  "align-items": "flex-start",
                                },
                              },
                              [
                                _c(
                                  "draggable",
                                  {
                                    attrs: {
                                      group: "userList",
                                      options: { handle: ".info_personnel1" },
                                      animation: "500",
                                    },
                                    model: {
                                      value: item.userList,
                                      callback: function ($$v) {
                                        _vm.$set(item, "userList", $$v)
                                      },
                                      expression: "item.userList",
                                    },
                                  },
                                  [
                                    _c(
                                      "transition-group",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-wrap": "wrap",
                                        },
                                      },
                                      _vm._l(
                                        item.userList,
                                        function (user, index2) {
                                          return _c(
                                            "div",
                                            {
                                              key: index2,
                                              staticClass: "user_personnel",
                                            },
                                            [
                                              _vm.channel === "wechat"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info_personnel1",
                                                    },
                                                    [
                                                      user.avatar != "" &&
                                                      user.avatar != null
                                                        ? _c("img", {
                                                            staticClass:
                                                              "info_personnel_surname1",
                                                            attrs: {
                                                              src: user.avatar,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _c(
                                                        "div",
                                                        [
                                                          _c("ww-open-data", {
                                                            attrs: {
                                                              type: "userName",
                                                              openid: user.name,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "info_personnel1",
                                                    },
                                                    [
                                                      user.avatar != "" &&
                                                      user.avatar != null
                                                        ? _c("img", {
                                                            staticClass:
                                                              "info_personnel_surname1",
                                                            attrs: {
                                                              src: user.avatar,
                                                            },
                                                          })
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "info_personnel_surname1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    user.name.substring(
                                                                      0,
                                                                      1
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(user.name)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-shanchu del_icon",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.delUsers(
                                                      item.userList,
                                                      index2,
                                                      index
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  [
                                    _vm.creatType === "waixie"
                                      ? _c("candidate", {
                                          attrs: {
                                            "is-multiple":
                                              item.type == "10" ? false : true,
                                            "is-show-icon": true,
                                            "setect-user": item.userList,
                                          },
                                          on: {
                                            getSetectUser: function (val) {
                                              return _vm.setupTaskFollow(
                                                val,
                                                index,
                                                item.type
                                              )
                                            },
                                          },
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "iconfont icon-jiahao2fill add_icon",
                                          staticStyle: { margin: "0 24px" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.contactCh(
                                                item.userList,
                                                index,
                                                item.type
                                              )
                                            },
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : item.type == "18"
                        ? _c(
                            "div",
                            { staticClass: "pop_table" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", plain: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.addRow(
                                            item.value.dataList,
                                            "",
                                            "",
                                            "bot"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "iconfont icon-jiahao1 creat-icon",
                                        staticStyle: {
                                          "font-size": "15px",
                                          color: "#fff",
                                        },
                                      }),
                                      _vm._v(" 新增 "),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-table",
                                {
                                  ref: "table",
                                  refInFor: true,
                                  staticClass: "scpc-task-table",
                                  attrs: {
                                    data:
                                      item.value.dataList &&
                                      item.value.dataList.length > 0
                                        ? item.value.dataList
                                        : [{}],
                                    "header-cell-style": {
                                      background: "#F1F1F1 ",
                                      fontSize: "14px",
                                      color: "#999999",
                                    },
                                    "cell-style": {
                                      fontSize: "14px",
                                    },
                                    height: "100%",
                                    border: "",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "empty",
                                      staticStyle: { display: "none" },
                                      attrs: { slot: "empty" },
                                      slot: "empty",
                                    },
                                    [_vm._v(" 暂无数据 ")]
                                  ),
                                  _c("el-table-column", {
                                    attrs: { type: "index" },
                                  }),
                                  _vm._l(
                                    item.value.headList,
                                    function (itemTab, index3) {
                                      return _c("el-table-column", {
                                        key: index3,
                                        attrs: {
                                          prop: itemTab.fieldName,
                                          "min-width": "200",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "header",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        position: "relative",
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            itemTab.fieldName
                                                          ) + " "
                                                        ),
                                                      ]),
                                                      _c("i", {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value:
                                                              itemTab.required ===
                                                              "1",
                                                            expression:
                                                              "itemTab.required === '1'",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "iconfont icon-bitian",
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                          color: "#FF4D42",
                                                          position: "absolute",
                                                          top: "-5px",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  itemTab.type === "0"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              type: "textarea",
                                                              autosize: "",
                                                              placeholder:
                                                                "请输入0",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row.value,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "value",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.value",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  itemTab.type === "1"
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              type: "textarea",
                                                              autosize: "",
                                                              placeholder:
                                                                "请输入1",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row.value,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "value",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.value",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    }
                                  ),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "operation",
                                      label: "操作",
                                      width: "100px",
                                      fixed: "right",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-popover",
                                                {
                                                  ref: "popInventory",
                                                  refInFor: true,
                                                  attrs: {
                                                    placement: "bottom",
                                                    width: "100",
                                                    trigger: "click",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "pop_item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.copyRow(
                                                              item.value
                                                                .dataList,
                                                              scope.row,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("复制")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "pop_item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.clearRow(
                                                              item.value
                                                                .dataList,
                                                              scope.row,
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("清空行数据")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "pop_item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.addRow(
                                                              item.value
                                                                .dataList,
                                                              scope.row,
                                                              scope.$index,
                                                              "top"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("在上面添加行")]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "pop_item",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.addRow(
                                                              item.value
                                                                .dataList,
                                                              scope.row,
                                                              scope.$index,
                                                              "bot"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("在下面面添加行")]
                                                    ),
                                                    item.value.dataList &&
                                                    item.value.dataList.length >
                                                      1
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pop_item",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.deleteRow(
                                                                  item.value
                                                                    .dataList,
                                                                  scope.row,
                                                                  scope.$index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v("删除")]
                                                        )
                                                      : _vm._e(),
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      attrs: {
                                                        slot: "reference",
                                                      },
                                                      slot: "reference",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-gengduo3 form_name_icon",
                                                        staticStyle: {
                                                          cursor: "pointer",
                                                          "font-size": "19px",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "info_value" },
                            [
                              _c("el-input", {
                                ref: "input_name",
                                refInFor: true,
                                attrs: {
                                  autofocus: true,
                                  placeholder: "点击添加",
                                },
                                on: { change: _vm.addFormData },
                                model: {
                                  value: item.fieldValue,
                                  callback: function ($$v) {
                                    _vm.$set(item, "fieldValue", $$v)
                                  },
                                  expression: "item.fieldValue",
                                },
                              }),
                            ],
                            1
                          ),
                    ]),
              ]),
          _c("VideoPreview", {
            attrs: { visible: _vm.showVideo, url: _vm.videoUrl },
            on: {
              "update:visible": [
                function ($event) {
                  _vm.showVideo = $event
                },
                function (val) {
                  return _vm.console.log("visible 更新为:", val)
                },
              ],
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }